import React from "react";
import ReactDOM from "react-dom";
import PortalReactDOM from "react-dom";
import { BlinkBlur } from "react-loading-indicators";
import { createPortal } from 'react-dom';
import SearchList from "../Search/SearchList";
import severUrl from "../../api";
import axios from "axios";
import { useState, useEffect, createContext, useContext } from "react";
import { SearchItem } from "../Search/SearchItem";

const options = { //Typescript ways of adding the type
  year: "numeric",
  month: "long",
};

// const WindowPortalContext = createContext(null);

// export const useWindowPortalContext = () => {
//   return useContext(WindowPortalContext);
// };


class FullScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "this is a header"
    };
  }



  onChange = ({ target }) => this.setState({ value: target.value });

  render() {
    const { keyword, results } = this.props;
    return (
      <React.Fragment >
        <Containment keyword={keyword} results={results} />
      </React.Fragment>
    );
  }
}

const Containment = (props) => ReactDOM.createPortal(
  <div className="custom-modal-portal">
    <div
      style={{
        // justifyContent: "center",
        textAlign: "center",
        width: "100%",
        // marginTop:"30%",
        top: "40px"
      }}
    >
      <h3>Search for keyword {props.keyword}</h3>
      {/* {props.results && <p>No result</p>} */}
     { props.results &&
      <ul className="search-container">
        {
          Array.from(props.results)
          .map( (value, index) => {
            console.log(value);
            return (
               <li><a href={value.slug}>{value.title}</a></li> )})

        }
        
      </ul>}

      {/* <ul className="search-container">
          <li>
          <a href="12x">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque suscipit finibus lectus vitae sodales. Praesent metus lorem, accumsan ut ullamcorper ac, aliquet sed lectus. Vivamus dapibus porttitor vestibulum. Aenean laoreet dignissim blandit. Pellentesque nibh nunc, consequat vitae nisi sit amet, accumsan efficitur tortor. Ut in erat enim. Sed at consequat leo. Etiam porttitor lacinia consectetur. Suspendisse in consequat nulla, id dictum turpis. Aenean accumsan arcu at nunc vestibulum lacinia. Nulla facilisi.</a></li>
          <li>
          <a>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque suscipit finibus lectus vitae sodales. Praesent metus lorem, accumsan ut ullamcorper ac, aliquet sed lectus. Vivamus dapibus porttitor vestibulum. Aenean laoreet dignissim blandit. Pellentesque nibh nunc, consequat vitae nisi sit amet, accumsan efficitur tortor. Ut in erat enim. Sed at consequat leo. Etiam porttitor lacinia consectetur. Suspendisse in consequat nulla, id dictum turpis. Aenean accumsan arcu at nunc vestibulum lacinia. Nulla facilisi.</a></li>
          <li>
          <a>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque suscipit finibus lectus vitae sodales. Praesent metus lorem, accumsan ut ullamcorper ac, aliquet sed lectus. Vivamus dapibus porttitor vestibulum. Aenean laoreet dignissim blandit. Pellentesque nibh nunc, consequat vitae nisi sit amet, accumsan efficitur tortor. Ut in erat enim. Sed at consequat leo. Etiam porttitor lacinia consectetur. Suspendisse in consequat nulla, id dictum turpis. Aenean accumsan arcu at nunc vestibulum lacinia. Nulla facilisi.</a></li>
        </ul> */}
    </div>
  </div>
  , document.body);


// const FullScreen = (props) => {

//   return createPortal(
//     <div className="custom-modal-portal">
//       <div
//         style={{
//           // justifyContent: "center",
//           textAlign: "center",
//           width: "100%",
//           // marginTop:"30%",
//           top: "40px"
//         }}
//       >
//         <h3>props</h3>
//       </div>
//     </div>,
//     document.body
//   );
// };

export default FullScreen;